/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../compat/compat-chat.component';
const styles_CompatChatComponent:any[] = ([] as any[]);
export const RenderType_CompatChatComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CompatChatComponent,
  data: {}
}
);
export function View_CompatChatComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_CompatChatComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-compat-chat',([] as any[]),(null as any),(null as any),(null as any),View_CompatChatComponent_0,RenderType_CompatChatComponent)),
    import0.ɵdid(49152,(null as any),0,import1.CompatChatComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CompatChatComponentNgFactory:import0.ComponentFactory<import1.CompatChatComponent> = import0.ɵccf('app-compat-chat',import1.CompatChatComponent,View_CompatChatComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1jaGF0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtY2hhdC5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtY2hhdC5jb21wb25lbnQudHMuQ29tcGF0Q2hhdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtY29tcGF0LWNoYXQ+PC9hcHAtY29tcGF0LWNoYXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/compat/compat-chat.component.ngfactory.ts